import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {DialogService} from "ng2-bootstrap-modal";
import {SendSignalService} from "../../../_services/send-signal.service";
import {LineBotService} from "../../../_services/line-bot.service";
import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";
import {DataTableDirective} from "angular-datatables";
import {PopupShowListCoinComponent} from "../popup-show-list-coin/popup-show-list-coin.component";
import {PopupCoinSendForUserComponent} from "./popup-coin-send-for-user/popup-coin-send-for-user.component";

@Component({
    selector: 'app-manage-coin-send-for-user',
    templateUrl: './manage-coin-send-for-user.component.html',
    styleUrls: ['../send-signal-event.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ManageCoinSendForUserComponent implements OnInit {

    lineBotAlls: Observable<any[]>;
    line_bot_id: string;
    parameters: any = {};
    delayTimer: any;
    //declare callback object
    callback: any = {};
    objPopUp: any;
    /**
     * filterBy = 1; // load all function send price not Active
     * filterBy = 0; // load active function send price Active
     * filterBy = 2; // load all
     */
    filterBy = 2; // default load all in Bot
    dtTrigger: Subject<any> = new Subject();
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;
    sendSignalName: string;
    constantSendSignal: any;

    constructor(private dialogService: DialogService,
                private sendSignalService: SendSignalService,
                private lineBotService: LineBotService) {
        this.constantSendSignal = this.sendSignalService.getConstantSendSignal();
    }

    ngOnInit() {
        let self = this;
        this.lineBotAlls = this.lineBotService.getLineBot();
        self.sendSignalPriceUserTable(this.lineBotAlls);
    }

    sendSignalPriceUserTable(lineBotAll: any) {
        let self = this;
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[1, "desc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.sendSignalName || '';
                parameters["search"]["is_active"] = self.filterBy;
                lineBotAll.subscribe(dataLineBot => {
                    parameters["search"]["line_bot_id"] = self.line_bot_id || dataLineBot[0].id;

                    //assign parameters object
                    self.parameters = parameters;
                    //assign callback object
                    self.callback = callback;

                    self.sendSignalService.getFunctionNameForUser(parameters).subscribe(result => {
                        callback({
                            draw: parameters['draw'],
                            data: result.data,
                            recordsTotal: result.data.length,
                            recordsFiltered: result.recordsTotal
                        });
                    });
                });
            },
            columns: [
                {
                    title: "イベント名",
                    name: "send_signal_name",
                    className: "all text-justify elementEventName",
                    data: 'send_signal_name',
                },
                {
                    title: "作成先",
                    data: "created_at",
                    name: "created_at",
                    className: "all text-justify",
                    width: '4%'
                },
                {
                    title: "更新先",
                    data: "updated_at",
                    name: "updated_at",
                    className: "all text-justify",
                    width: '4%'
                },
                {
                    title: "編集する",
                    data: function (d) {
                        return `<button class="btn btn-sm btn-edit">編集</button>`;
                    },
                    width: '120px',
                    className: "all text-center",
                    orderable: false
                },
                {
                    title: "イベント設定",
                    data: 'btn_block',
                    width: '120px',
                    className: "all text-center",
                    orderable: false
                }
            ],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                $('.btn-edit', row).bind('click', () => {
                    self.openModalSettingCoinPrice(data);
                });
                $('.btn-set-bot', row).bind('click', () => {
                    self.setSettingCoinPrice(data);
                });

                var btn_edit = $(row).find('td').find('.btn-edit');
                btn_edit.css({
                    'background-color': 'deepskyblue',
                    'color': '#fff'
                });
                btn_edit.mouseover(function () {
                    btn_edit.css('opacity', '0.9');
                });
                btn_edit.mouseout(function () {
                    btn_edit.css('opacity', '1');
                });

                let clientWidth = document.documentElement.clientWidth;
                let maxWidth = clientWidth < 850
                    ? 20
                    : (clientWidth > 850 && clientWidth < 1200)
                        ? 150
                        : (clientWidth > 1200 && clientWidth < 1500)
                            ? 300
                            : (clientWidth > 1500 && clientWidth < 1700)
                                ? 350
                                : 400;
                var td_row = $(row).find('td.elementEventName');
                td_row.css({
                    'word-wrap': 'break-word',
                    'max-width': maxWidth + 'px',
                    'white-space': 'nowrap',
                    'overflow': 'hidden',
                    'text-overflow': 'ellipsis'
                });

                if (data['is_active'] == 1) {
                    $(row).css('background-color', '#3c8dbc');

                    var btn_active_bot = $(row).find('td:last').find('.btn-active-bot');
                    btn_active_bot.css({
                        'background-color': 'HotPink',
                        'border-color': 'HotPink'
                    });
                    btn_active_bot.mouseover(function () {
                        btn_active_bot.css('opacity', '0.8');
                    });
                    btn_active_bot.mouseout(function () {
                        btn_active_bot.css('opacity', '1');
                    });
                }
                return row;
            }
        };
    }

    openModalSettingCoinPrice(dataObject?: any) {
        let self = this;
        this.constantSendSignal.subscribe(constantSendSignal => {
            let listCoinID = dataObject ? dataObject.list_coin_id : null;
            let lineBotID = dataObject ? dataObject.line_bot_id : $('#line-bot :selected').val();
            this.sendSignalService.postListCoinActive({listCoinID: listCoinID}).subscribe((resCoinList: Response) => {
                self.objPopUp = {
                    constantSendSignal: constantSendSignal.constants,
                    data: dataObject,
                    titlePopup: 'ユーザーにプライスを送信するコインの管理' + (dataObject ? '（編集）' : '（追加）'),
                    listCoinSendSignal: resCoinList,
                    btnSaveOrUpdate: (dataObject ? '更新' : '保存'),
                    lineBotID: lineBotID,
                    codeSendSignalEvent: dataObject ? dataObject.code_send_signal_event : ''
                };

                this.dialogService.addDialog(PopupCoinSendForUserComponent, self.objPopUp).subscribe((isAccess) => {
                    if (isAccess) {
                        this.loadCurrentPage();
                    }
                });
            });
        });
    }

    setSettingCoinPrice(dataObject: any) {
        let self = this;
        this.sendSignalService.setSendSignalFunctionActive(dataObject).subscribe(data => {
            if (!data.error) {
                self.loadCurrentPage();
            } else {
                alert(data.message);
            }
        }, error => {
            alert(error.json().message);
        });
    }

    loadCurrentPage() {
        //get parameters and retrive result of current page
        this.sendSignalService.getFunctionNameForUser(this.parameters).subscribe(result => {
            this.callback({
                draw: this.parameters['draw'],
                data: result.data,
                recordsTotal: result.data.length,
                recordsFiltered: result.recordsTotal
            });
        });
    }

    onChangeFilter(value) {
        this.filterBy = value;
        this.renderDataTable();
    }

    renderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.renderDataTable();
        }, 600); // Will do the ajax stuff aft
    };

    valueChange(newValue) {
        this.sendSignalName = newValue;
        this.doSearch();
    }

    onChangeLineBot(event) {
        this.line_bot_id = event.target.value;
        this.renderDataTable();
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/send-signal-event/manage-coin-send-for-user/manage-coin-send-for-user.component.ts